/* eslint-disable react/prop-types */
import React, { createContext, useState } from "react";

export const StickyContext = createContext({
  desktop: {
    setValue: v => v,
    value: false
  },
  mobile: {
    setValue: v => v,
    value: false
  }
});
StickyContext.displayName = "StickyContext";

const StickyContextProvider = props => {
  const [mobileSticky, setMobileSticky] = useState(props.defaultValue);
  const [desktopSticky, setDesktopSticky] = useState(props.defaultValue);
  const providerValue = {
    desktop: { setValue: setDesktopSticky, value: desktopSticky },
    mobile: { setValue: setMobileSticky, value: mobileSticky }
  };

  return <StickyContext.Provider {...props} value={providerValue} />;
};

export const withStickyContextProvider = (
  Component,
  defaultValue = false
) => props => (
  <StickyContextProvider defaultValue={defaultValue}>
    <Component {...props} />
  </StickyContextProvider>
);
